<div class="flex w-full flex-col gap-4 p-5">
  @let hasChanges = hasUnsavedChanges(licenseForm);
  <div class="mr-auto flex w-fit flex-wrap">
    <aw-button
      id="license-back"
      type="button"
      [style]="'tertiary'"
      buttonSize="small"
      (click)="navigateBack()">
      <span class="material-symbols-rounded mr-1">arrow_back</span>
      Zurück
    </aw-button>
  </div>
  <aw-section-header>
    <aw-section-headline>
      {{ cmsTextProvider.license.headline }}
    </aw-section-headline>
    <aw-section-header-actions>
      <aw-button
        id="license-cancel"
        type="button"
        [isDisabled]="!hasChanges"
        (click)="handleAbortChangesDialog()"
        [text]="cmsTextProvider.shared.cancel"
        [style]="'primary-alt'" />
      <aw-button
        id="license-save"
        type="button"
        [isDisabled]="!hasChanges"
        (click)="save()"
        [text]="cmsTextProvider.shared.save"
        [style]="'primary'" />
    </aw-section-header-actions>
  </aw-section-header>

  <aw-simple-table
    id="license-table"
    [data]="licenseForm.controls.licenses.controls"
    [isLoading]="licenseStore.isLoading()"
    [header]="header"
    [columns]="columns">
    <ng-template #header>
      <div>
        {{ cmsTextProvider.license.licenseDesignation }}
      </div>
      <div>
        <div class="flex items-center gap-2">
          <img
            src="images/amcon-webshop.svg"
            alt="Amcon App Logo"
            [attr.data-testid]="'app-logo-image'" />
          {{ cmsTextProvider.license.web }}
        </div>
      </div>
      <div>
        <div class="flex items-center gap-2">
          <img
            src="images/amcon-app.svg"
            alt="Amcon App Logo"
            [attr.data-testid]="'app-logo-image'" />
          {{ cmsTextProvider.license.app }}
        </div>
      </div>
    </ng-template>

    <ng-template #columns let-licenseForm="data">
      <div>
        <span class="text-xl font-semibold">{{
          licenseForm.controls.label.value
        }}</span>
      </div>
      <div>
        <ng-container
          *ngTemplateOutlet="
            channelToggle;
            context: { licenseForm: licenseForm, channel: 'webState' }
          " />
      </div>
      <div>
        <ng-container
          *ngTemplateOutlet="
            channelToggle;
            context: { licenseForm: licenseForm, channel: 'appState' }
          " />
      </div>
    </ng-template>

    <ng-template
      #channelToggle
      let-licenseForm="licenseForm"
      let-channel="channel">
      @if (isChannelUnavailable(licenseForm, channel)) {
        <span
          class="material-symbols-rounded text-standard-text-secondary ml-3 cursor-not-allowed"
          title="Nicht verfügbar"
          aria-label="Nicht verfügbar">
          block
        </span>
      } @else {
        <aw-toggle
          class="w-auto"
          [id]="'license-' + licenseForm.controls.key.value + '-' + channel"
          [label]="''"
          [activeValue]="LicenseChannelState.Active"
          [inactiveValue]="LicenseChannelState.Inactive"
          [formControl]="licenseForm.controls[channel]" />
      }
    </ng-template>
  </aw-simple-table>
</div>
